import Home from "./component/Home";
import { BrowserRouter as Router } from "react-router-dom";

function App() {
  return (
    <>
      <Router>
        <Home />
      </Router>
    </>
  );
}

export function format(number) {
  try {
    if (number == undefined) {
      throw new Error();
    }
    return Number(number)
      .toFixed(0)
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  } catch (error) {
    return 0;
  }
}

export function formatFloatNumber(number) {
  if (typeof number !== "number") {
    number = parseFloat(number);
  }
  if (isNaN(number)) {
    return "0.00"; // or any fallback value
  }
  return number.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export default App;
